export const INVALID_ICON_TOOLTIP_WARNING =
  '[ChirpTag] The `icon`, `iconPosition`, and `iconAriaLabel` props are not supported when `tooltipProps` is provided. Custom icons are ignored.';

/**
 * Non-production warning for invalid JS usage that bypasses TypeScript exclusivity.
 */
export const warnInvalidIconWithTooltip = (
  hasTooltip: boolean,
  hasCustomIconProps: boolean
): void => {
  if (process.env.NODE_ENV !== 'production' && hasTooltip && hasCustomIconProps) {
    // Intentional developer warning for invalid runtime prop combinations.
    // eslint-disable-next-line no-console -- warn in non-production only
    console.warn(INVALID_ICON_TOOLTIP_WARNING);
  }
};
